import { urls } from './';

const images = {
  logo: `${urls.assets}img/logo-principal@2x.png`,
  logo_white: `${urls.assets}img/logo-principal-white@2x.png`,
  btn_topo: `${urls.assets}img/btn-voltar-topo.svg`,
  bgs: {
    bg_green: `${urls.assets}img/bgs/bg-green.png`,
  },
  home: {
    nosso_ano: `${urls.assets}img/home/home-nosso-ano.png`,
    presidencia: `${urls.assets}img/home/home-presidencia.png`,
    superintendencia: `${urls.assets}img/home/home-superintendencia.png`,
    bg_mensagens: `${urls.assets}img/home/icon-mensagens.svg`,
    bg_linha_do_tempo: `${urls.assets}img/home/bg-linha-do-tempo.png`,
    icon_linha_do_tempo: `${urls.assets}img/home/icon-linha-do-tempo.svg`,
    pessoa_linha_do_tempo: `${urls.assets}img/home/pessoa-linha-do-tempo.png`,
    bg_eventos: `${urls.assets}img/home/bg-eventos-2.png`,
    pessoasRH_01: `${urls.assets}img/home/pessoas-rh-01.png`,
    pessoasRH_02: `${urls.assets}img/home/pessoas-rh-02.png`,
    pessoasRH_03: `${urls.assets}img/home/pessoas-rh-03.png`,
  },

  quem_somos: {
    first_bg: `${urls.assets}img/quem-somos/first-background_v2.png`,
    img_quem_somos: `${urls.assets}img/quem-somos/img_quem_somos.png`,
    icon_missao: `${urls.assets}img/quem-somos/icon_missao.png`,
    icon_visao: `${urls.assets}img/quem-somos/icon_visao.png`,
    icon_valores: `${urls.assets}img/quem-somos/icon_valores.png`,
    galgo: `${urls.assets}img/quem-somos/logo-galgo-sa.png`,
    rtm: `${urls.assets}img/quem-somos/logo-rtm.png`,
    pessoa1: `${urls.assets}img/quem-somos/pessoa-1.png`,
    pessoa2: `${urls.assets}img/quem-somos/pessoa-2.png`,
    pessoa3_corpo: `${urls.assets}img/quem-somos/pessoa3-corpo.png`,
    pessoa3_cabeca: `${urls.assets}img/quem-somos/pessoa3-cabeca.png`,
    pessoa3_braco: `${urls.assets}img/quem-somos/pessoa3-braco.png`,
  },
  associados: {
    associadosCasas: `${urls.assets}img/associados/predios-hero-associados.png`,
    casalMesa: `${urls.assets}img/associados/casal-mesa.png`,
    bgAssociados: `${urls.assets}img/associados/bg-associados.jpg`,
    build1: `${urls.assets}img/associados/build-1.svg`,
    build2: `${urls.assets}img/associados/build-2.svg`,
    build3: `${urls.assets}img/associados/build-3.svg`,
    build4: `${urls.assets}img/associados/build-4.svg`,
    build5: `${urls.assets}img/associados/build-5.svg`,
    build6: `${urls.assets}img/associados/build-6.svg`,
    build7: `${urls.assets}img/associados/build-7.svg`,
    build1_mobile: `${urls.assets}img/associados/build-1_mobile.svg`,
    build2_mobile: `${urls.assets}img/associados/build-2_mobile.svg`,
    build3_mobile: `${urls.assets}img/associados/build-3_mobile.svg`,
    build4_mobile: `${urls.assets}img/associados/build-4_mobile.svg`,
    build5_mobile: `${urls.assets}img/associados/build-5_mobile.svg`,
    build6_mobile: `${urls.assets}img/associados/build-6_mobile.svg`,
    build7_mobile: `${urls.assets}img/associados/build-7_mobile.svg`,
    arvoresEsq: `${urls.assets}img/associados/arvores-esquerda.svg`,
    arvoresDir: `${urls.assets}img/associados/arvores-direita.svg`,
    MapaBrasilSvg2019: `${urls.assets}img/associados/mapa-brasil-2019.svg`,
    MapaBrasilSvg2018: `${urls.assets}img/associados/mapa-brasil-2018.svg`,
    MapaBrasilSvg2017: `${urls.assets}img/associados/mapa-brasil-2017.svg`,
    bgMapa: `${urls.assets}img/bgs/bg-blue.png`,
    papelGrafico: `${urls.assets}img/associados/papel-grafico.svg`,
    papelLupa: `${urls.assets}img/associados/papel-lupa.svg`,
    personagemConselho: `${urls.assets}img/associados/personagem-conselho-etica.png`,
    iconeLapis: `${urls.assets}img/associados/lapis.svg`,
    WhatsMensagens: `${urls.assets}img/associados/mensagens-whats.png`,
    WhatsMensagensPessoa: `${urls.assets}img/associados/mensagens-whats-pessoa.png`,
    likeIcon: `${urls.assets}img/associados/like-icon.svg`,
    iconeGrupos: `${urls.assets}img/associados/icone-grupos.svg`,
  },
  sobre_relatorio: {
    first_bg: `${urls.assets}img/sobre-relatorio/first-background.png`,
    second_bg: `${urls.assets}img/sobre-relatorio/second-background.png`,
    third_bg: `${urls.assets}img/sobre-relatorio/third-background.png`,
    icon_gerencia: `${urls.assets}img/sobre-relatorio/icon_gerencia.png`,
    icon_coord_conteudo: `${urls.assets}img/sobre-relatorio/icon_coord_conteudo.png`,
    icon_redacao: `${urls.assets}img/sobre-relatorio/icon_redacao.png`,
    icon_coord_digital: `${urls.assets}img/sobre-relatorio/icon_coord_digital.png`,
    icon_edicao: `${urls.assets}img/sobre-relatorio/icon_edicao.png`,
    icon_projeto: `${urls.assets}img/sobre-relatorio/icon_projeto.png`,
    logo_creditos_fullbar: `${urls.assets}img/sobre-relatorio/creditos-logo-fullbar.png`,
    pessoa1: `${urls.assets}img/sobre-relatorio/pessoa-1.png`,
    pessoa2: `${urls.assets}img/sobre-relatorio/pessoa-2.png`,
    pessoa3: `${urls.assets}img/sobre-relatorio/pessoa-3.png`,
    fundo_pessoa1_1: `${urls.assets}img/sobre-relatorio/fundo-pessoa-1-1.png`,
    fundo_pessoa1_2: `${urls.assets}img/sobre-relatorio/fundo-pessoa-1-2.png`,
    fundo_pessoa2: `${urls.assets}img/sobre-relatorio/fundo-pessoa-2.png`,
  },

  plano_acao: {
    first_bg: `${urls.assets}img/plano-acao/first-background.png`,
    img_plano_acao: `${urls.assets}img/plano-acao/img_plano_acao.png`,
    bg_temas: `${urls.assets}img/plano-acao/bg_temas_institucionais.png`,
    pessoa1: `${urls.assets}img/plano-acao/pessoa1.png`,
    pessoa2: `${urls.assets}img/plano-acao/pessoa2.png`,
    pessoa3: `${urls.assets}img/plano-acao/pessoa3.png`,
    pessoas_destaque: `${urls.assets}img/plano-acao/pessoa_destaque_final.png`,
    bg_estrutura_representacao1: `${urls.assets}img/plano-acao/icon-estrutura-representacao1.png`,
    bg_estrutura_representacao2: `${urls.assets}img/plano-acao/icon-estrutura-representacao2.png`,
  },

  plano_acao_2019: {
    hero_imagem: `${urls.assets}img/plano-acao-2019/hero-plano-acao-2019.png`,
    icone_formentar_financiamento: `${urls.assets}img/plano-acao-2019/icone-formentar-financiamento.svg`,
    icone_volume: `${urls.assets}img/plano-acao-2019/icone-volume.svg`,
    icone_aumentar: `${urls.assets}img/plano-acao-2019/icone-aumentar.svg`,
    icone_investidores: `${urls.assets}img/plano-acao-2019/icone-investidores.svg`,
    icone_foguete: `${urls.assets}img/plano-acao-2019/icone-foguete.svg`,
    icone_aprimorar: `${urls.assets}img/plano-acao-2019/icone-aprimorar.svg`,
    icone_promover_agenda: `${urls.assets}img/plano-acao-2019/icone-promover-agenda.svg`,
    icone_aprimorar_atividade: `${urls.assets}img/plano-acao-2019/icone-aprimorar-atividade.svg`,
    icone_fortalecer: `${urls.assets}img/plano-acao-2019/icone-fortalecer.svg`,
    icone_reavaliar: `${urls.assets}img/plano-acao-2019/icone-reavaliar.svg`,
    icone_conduzir_acoes: `${urls.assets}img/plano-acao-2019/icone-conduzir-acoes.svg`,
    icone_discussoes_tecnologia: `${urls.assets}img/plano-acao-2019/icone-discussoes-tecnologia.svg`,
    icone_equiparar_supervisoes: `${urls.assets}img/plano-acao-2019/icone-equiparar-supervisoes.svg`,
    icone_ciberseguranca: `${urls.assets}img/plano-acao-2019/icone-ciberseguranca.svg`,
    personagem_acao_2019: `${urls.assets}img/plano-acao-2019/personagem-acao-2019.png`,
    pessoa_destaque: `${urls.assets}img/plano-acao-2019/pessoa_destaque.png`,
    braco_homem: `${urls.assets}img/plano-acao-2019/braco-homem.svg`,
    ilustra: `${urls.assets}img/plano-acao-2019/ilustra.svg`,
    lines: `${urls.assets}img/plano-acao-2019/lines.svg`,
  },
  sumario: {
    sumario_hero: `${urls.assets}img/sumario/sumario-hero.png`,
    braco_homem: `${urls.assets}img/sumario/braco-homem.svg`,
    homem: `${urls.assets}img/sumario/homem.svg`,
    lupa_mulher: `${urls.assets}img/sumario/lupa-mulher.svg`,
    mulher: `${urls.assets}img/sumario/mulher2.svg`,
    pc: `${urls.assets}img/sumario/pc.svg`,
  },
  diretoria: {
    urlDiretores: `${urls.assets}img/diretoria/`,
    pessoa1: `${urls.assets}img/diretoria/pessoa1.png`,
    pessoa1_hover: `${urls.assets}img/diretoria/pessoa1-hover.png`,
    pessoa2: `${urls.assets}img/diretoria/pessoa2.png`,
    icon_btn: `${urls.assets}img/diretoria/icon-btn.png`,
    diretor1: `${urls.assets}img/diretoria/diretoria1.png`,
  },

  icons: {
    time_green: `${urls.assets}img/icons/time-green@2x.png`,
    calendar_blue: `${urls.assets}img/icons/calendar-blue@2x.png`,
    calendar_square_yellow: `${urls.assets}img/icons/calendar-square-yellow.png`,
    comment_yellow: `${urls.assets}img/icons/comment-yellow@2x.png`,
    comment_white: `${urls.assets}img/icons/comment-white.png`,
    hands: `${urls.assets}img/icons/hands.png`,
    book: `${urls.assets}img/icons/book.png`,
    circles: `${urls.assets}img/icons/circles.png`,
    icone_down_up: `${urls.assets}img/icons/icone-down-up.svg`,
    comissoes: `${urls.assets}img/icons/ico-comissoes.svg`,
    comissoes_dark: `${urls.assets}img/icons/ico-comissoes-dark.svg`,
    foruns: `${urls.assets}img/icons/ico-foruns.svg`,
    foruns_dark: `${urls.assets}img/icons/ico-foruns-dark.svg`,
    emergentes: `${urls.assets}img/icons/ico-emergentes.svg`,
    emergentes_dark: `${urls.assets}img/icons/ico-emergentes-dark.svg`,
    permanentes: `${urls.assets}img/icons/ico-permanentes.svg`,
    permanentes_dark: `${urls.assets}img/icons/ico-permanentes-dark.svg`,
    globe_yellow: `${urls.assets}img/icons/globe-yellow.png`,
    responsabilidades_yellow: `${urls.assets}img/icons/responsabilidades-yellow.png`,
    legal_yellow: `${urls.assets}img/icons/legal-yellow.png`,
    lamp_yellow: `${urls.assets}img/icons/lamp-yellow.png`,
    chevron_dark_top: `${urls.assets}img/icons/chevron-dark-top.svg`,
  },

  profiles: {
    carlos_ambrosio: `${urls.assets}img/profiles/carlos-ambrosio.png`,
    carlos_ambrosio_GRANDE: `${urls.assets}img/profiles/carlos-ambrosio_GRANDE.png`,
    jose_laloni: `${urls.assets}img/profiles/jose-laloni.png`,
    luiz_sorge: `${urls.assets}img/profiles/luiz-sorge.png`,
    pedro_rudge: `${urls.assets}img/profiles/pedro-rudge.png`,
    jose_carlos_doherty: `${urls.assets}img/profiles/jose-carlos-doherty.png`,
  },

  mensagens: {
    bg_azul: `${urls.assets}img/mensagens/bg-mensagens-azul.png`,
    bg_amarelo: `${urls.assets}img/mensagens/bg-mensagens-amarelo.png`,
    carlos_ambrosio: `${urls.assets}img/mensagens/carlos-ambrosio.png`,
    carlos_ambrosio_GRANDE: `${urls.assets}img/mensagens/carlos-ambrosio-grande.png`,
    zeca_doherty: `${urls.assets}img/mensagens/zeca-doherty.png`,
    zeca_doherty_GRANDE: `${urls.assets}img/mensagens/zeca-doherty-grande.png`,
    bg_rodape: `${urls.assets}img/mensagens/bg-rodape.png`,
  },

  governanca: {
    pessoas: `${urls.assets}img/governanca/pessoas-topo.png`,
    pessoas_topo1: `${urls.assets}img/governanca/pessoas-topo-1.png`,
    pessoas_topo2: `${urls.assets}img/governanca/pessoas-topo-2.png`,
    pessoa1: `${urls.assets}img/governanca/box-pill-human.svg`,
  },

  conselho_fiscal: {
    path_url: `${urls.assets}img/conselho-fiscal/`,
    ilustra1: `${urls.assets}img/conselho-fiscal/ilustra1.png`,
    ilustra1_1: `${urls.assets}img/conselho-fiscal/ilustra1-1.png`,
    ilustra1_2: `${urls.assets}img/conselho-fiscal/ilustra1-2.png`,
    pessoa1: `${urls.assets}img/conselho-fiscal/pessoa1.png`,
  },

  comite_executivo: {
    path_url: `${urls.assets}img/comite-executivo/`,
    ilustra1: `${urls.assets}img/comite-executivo/ilustra1.png`,
    ilustra1_1: `${urls.assets}img/comite-executivo/ilustra1-1.png`,
    pessoa1: `${urls.assets}img/comite-executivo/pessoa1.png`,
  },

  conselho_etica: {
    path_url: `${urls.assets}img/conselho-de-etica/`,
    ilustra1: `${urls.assets}img/conselho-de-etica/ilustra1.png`,
    icone1: `${urls.assets}img/conselho-de-etica/icones-pill.png`,
    icone1_mobile: `${urls.assets}img/conselho-de-etica/icones-pill--mobile.png`,
  },

  organismos: {
    first_bg: `${urls.assets}img/organismos-representacao/first-bg.png`,
    pessoa1: `${urls.assets}img/organismos-representacao/pessoa1.png`,
  },

  pessoas: {
    pessoas_topo1_mobile: `${urls.assets}img/pessoas/pessoas-topo.png`,
    pessoas_topo1: `${urls.assets}img/pessoas/pessoas-topo1.png`,
    pessoas_topo2: `${urls.assets}img/pessoas/pessoas-topo2.png`,
    pessoas_topo3: `${urls.assets}img/pessoas/pessoas-topo3.png`,
    pessoa1: `${urls.assets}img/pessoas/pessoa1.png`,
    pessoaSP: `${urls.assets}img/pessoas/pessoa-sp.png`,
    pessoaRJ: `${urls.assets}img/pessoas/pessoa-rj.png`,
    pessoaSelic: `${urls.assets}img/pessoas/pessoa-selic.png`,
    percent: `${urls.assets}img/pessoas/PERCENT.png`,
    mulher: `${urls.assets}img/pessoas/pessoa-mulher.png`,
    homem: `${urls.assets}img/pessoas/pessoa-homem.png`,
    symbol_mulher: `${urls.assets}img/pessoas/symbol-mulher.png`,
    symbol_homem: `${urls.assets}img/pessoas/symbol-homem.png`,
    mountain: `${urls.assets}img/pessoas/mountain.png`,
    pessoaAbaixo30anos: `${urls.assets}img/pessoas/pessoa-abaixo-30anos.png`,
    pessoa30a50anos: `${urls.assets}img/pessoas/pessoa-30-50-anos.png`,
    pessoaAcima50anos: `${urls.assets}img/pessoas/pessoa-acima-50-anos.png`,
    pessoaDestaque2: `${urls.assets}img/pessoas/pessoa-destaque-2.png`,
  },

  relacionamentos: {
    pessoas_topo: `${urls.assets}img/relacionamentos/pessoas-topo.png`,
    pessoas_topo_corpo: `${urls.assets}img/relacionamentos/pessoas-corpo.png`,
    cabeca_mulher: `${urls.assets}img/relacionamentos/cabeca-mulher.png`,
    cabeca_homem: `${urls.assets}img/relacionamentos/cabeca-homem.png`,
    braco: `${urls.assets}img/relacionamentos/braco.png`,
    pessoa_destaque: `${urls.assets}img/relacionamentos/pessoa-destaque.png`,
  },

  nosso_ano: {
    pessoa_topo: `${urls.assets}img/nosso-ano/first-image-man.png`,
    ponteiro: `${urls.assets}img/nosso-ano/ponteiro.png`,
    pessoa_destaque: `${urls.assets}img/nosso-ano/pessoa-destaque.png`,
  },

  para_o_mercado: {
    grafico_gestao: `${urls.assets}img/para-o-mercado/grafico-gestao.png`,
    grafico_fundos: `${urls.assets}img/para-o-mercado/grafico-fundos.png`,
    grafico_imk: `${urls.assets}img/para-o-mercado/grafico-imk.png`,
    grafico_ativos: `${urls.assets}img/para-o-mercado/grafico-ativos.png`,

    agenda_recursos: {
      bg_card: `${urls.assets}img/para-o-mercado/agenda-recursos/bg-card.png`,
    },
  },

  dentro_de_casa: {
    image_cultura: `${urls.assets}img/dentro-de-casa/image-cultura.png`,
  },

  organograma: {
    pessoa_topo: `${urls.assets}img/organograma/first-image-man.png`,
    quadro_topo: `${urls.assets}img/organograma/first-image-quadro.png`,
    pessoa_destaque: `${urls.assets}img/organograma/pessoa-destaque.png`,
  },

  iniciativas: {
    treinamentos: {
      pessoas: `${urls.assets}img/iniciativas/treinamentos/pessoas-treinamentos.png`,
      mulher: `${urls.assets}img/iniciativas/treinamentos/mulher.svg`,
      homem: `${urls.assets}img/iniciativas/treinamentos/homem.svg`,
    },
    raio_x: {
      capa: `${urls.assets}img/iniciativas/raio-x/capa-investidores-2019.png`,
      pessoa: `${urls.assets}img/iniciativas/raio-x/pessoa.png`,
      fim1: `${urls.assets}img/iniciativas/raio-x/fim1.png`,
      fim2: `${urls.assets}img/iniciativas/raio-x/fim2.png`,
      fim3: `${urls.assets}img/iniciativas/raio-x/fim3.png`,
    },
    cursos_educativos: {
      pessoa: `${urls.assets}img/iniciativas/cursos-educativos/pessoa.png`,
    },
    supervisao_ativos: {
      icones: `${urls.assets}img/iniciativas/supervisao-ativos/icones.png`,
    },
    cultura_dados: {
      photo1: `${urls.assets}img/iniciativas/cultura-de-dados/photo1.png`,
      photo2: `${urls.assets}img/iniciativas/cultura-de-dados/photo2.png`,
    },
    certificacao_educacao: {
      mapa: `${urls.assets}img/iniciativas/certificacao-educacao/mapa3.svg`,
      mapa_mobile: `${urls.assets}img/iniciativas/certificacao-educacao/mapa_mobile3.svg`,
    },
  },

  linha_do_tempo: {
    perna: `${urls.assets}img/linha-do-tempo/perna.png`,
    corpo: `${urls.assets}img/linha-do-tempo/corpo.png`,
    line: `${urls.assets}img/linha-do-tempo/linha.png`,
    line_mobile: `${urls.assets}img/linha-do-tempo/line.png`,
    pessoas_destaque: `${urls.assets}img/linha-do-tempo/pessoas-destaque.png`,
    doismil_09: {
      primeira: `${urls.assets}img/linha-do-tempo/2009/01.png`,
    },
    doismil_12: {
      primeira: `${urls.assets}img/linha-do-tempo/2012/01.png`,
    },
    doismil_13: {
      primeira: `${urls.assets}img/linha-do-tempo/2013/01.png`,
    },
    doismil_14: {
      primeira: `${urls.assets}img/linha-do-tempo/2014/01.png`,
    },
    doismil_16: {
      primeira: `${urls.assets}img/linha-do-tempo/2016/01.png`,
      segunda: `${urls.assets}img/linha-do-tempo/2016/02.png`,
    },
    doismil_17: {
      primeira: `${urls.assets}img/linha-do-tempo/2017/01.png`,
      pc: `${urls.assets}img/linha-do-tempo/2017/pc.png`,
    },
    doismil_18: {
      primeira: `${urls.assets}img/linha-do-tempo/2018/01.png`,
      segunda: `${urls.assets}img/linha-do-tempo/2018/02.png`,
    },
    doismil_19: {
      primeira: `${urls.assets}img/linha-do-tempo/2019/01.png`,
      segunda: `${urls.assets}img/linha-do-tempo/2019/02_2.png`,
      terceira: `${urls.assets}img/linha-do-tempo/2019/03.png`,
    },
  },

  eventos: {
    topo: `${urls.assets}img/eventos/eventos-area.png`,
    bg: `${urls.assets}img/eventos/eventos-bg.png`,
    pessoa: `${urls.assets}img/eventos/pessoa.png`,
  },

  menuAberto: {
    pessoa: `${urls.assets}img/menu/pessoa-menu.png`,
  },
};

export { images };
